import { render, staticRenderFns } from "./identificationCondition.vue?vue&type=template&id=68b99a1a&scoped=true"
import script from "./identificationCondition.vue?vue&type=script&lang=js"
export * from "./identificationCondition.vue?vue&type=script&lang=js"
import style0 from "./identificationCondition.vue?vue&type=style&index=0&id=68b99a1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b99a1a",
  null
  
)

export default component.exports